<caixa-webcomponent-navigation-bar [showMyFinance]="false" [showConnectAccounts]="false" />

<caixa-webcomponent-header-accounts/>

<caixa-webcomponent-main-title
  text="Meu financeiro"
  [lastUpdate]="summary.lastUpdatedAt$ | async"
/>

<bfm-dashboard-summary
  #summary
  title=""
  [enableTransitoryAccountsFilter]="false"
  [showTooltipsIcons]="true"
/>
